import React from 'react';

// Pastille ronde « non lu » : chiffre blanc sur rouge, masquée à zéro.
export const UnreadBadge = ({ count, className = '' }) => {
  if (!count) return null;
  return (
    <span
      className={`inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full bg-red-500 text-white text-xs font-semibold leading-none ${className}`}
      aria-label={`${count} non lu${count > 1 ? 's' : ''}`}
      data-testid="unread-badge"
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};

// Petit point rouge sur l'avatar d'une ligne non lue.
export const UnreadDot = ({ show }) => {
  if (!show) return null;
  return (
    <span
      className="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-red-500 border-2 border-white"
      aria-label="Non lu"
      data-testid="unread-dot"
    />
  );
};

export default UnreadBadge;
